import React from 'react';

export default function Footer() {
  return (
    <div className='footer'>Alchemy Code Lab 2022</div>
  );
}
